// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CoverMyMedsInboundEnrollmentPrescriptionDefinitionModel {
    static getAttributeTypeMap() {
        return CoverMyMedsInboundEnrollmentPrescriptionDefinitionModel.attributeTypeMap;
    }
}
CoverMyMedsInboundEnrollmentPrescriptionDefinitionModel.discriminator = undefined;
CoverMyMedsInboundEnrollmentPrescriptionDefinitionModel.additionalProperties = false;
CoverMyMedsInboundEnrollmentPrescriptionDefinitionModel.attributeTypeMap = [
    {
        "name": "daysSupply",
        "baseName": "daysSupply",
        "type": "number"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "ndc",
        "baseName": "ndc",
        "type": "string"
    },
    {
        "name": "refills",
        "baseName": "refills",
        "type": "number"
    },
    {
        "name": "sig",
        "baseName": "sig",
        "type": "string"
    },
    {
        "name": "writtenQuantity",
        "baseName": "writtenQuantity",
        "type": "string"
    },
];
//# sourceMappingURL=coverMyMedsInboundEnrollmentPrescriptionDefinitionModel.js.map